import React,{useSyncExternalStore}from'react';
import{getMacroRegime,subscribeMacroRegime}from'../data/macroRegimeStore.js';
import{deriveTimingContext}from'../data/timingContext.js';

const label=v=>String(v||'MISSING').replaceAll('_',' ');
const pct=v=>v==null||!Number.isFinite(Number(v))?'—':(Number(v)>=0?'+':'')+Number(v).toFixed(1)+'%';

export default function TimingDecision({research={}}){
 const macro=useSyncExternalStore(subscribeMacroRegime,getMacroRegime,getMacroRegime);
 const t=deriveTimingContext(research,macro);
 const bits=[
  label(t.pricePosition),
  label(t.volatility),
  'Horse '+label(t.macroState),
  'Pig '+label(t.sectorClarity)
 ];
 return <div className={'card decision timing-decision timing-'+String(t.state||'review').toLowerCase().replaceAll('_','-')}><small>TIMING · LIVE CONTEXT</small><h3>{label(t.state)}</h3><p>{bits.join(' · ')}</p><div className="timing-mini"><span>120W {pct(t.distance120wPct)}</span><span>Vol {pct(t.annualizedVolatilityPct)}</span><span>{t.cautions.length} caution</span><span>{t.supports.length} support</span></div><em>No entry or capital permission</em></div>;
}
